<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d12e29">Praise for Denise Hunter’s Novels</p>
<p class="tx1" id="d12e31">“. . . [S]ure to grab readers by the heart.”</p>
<p class="txR" id="d12e33">—<i>Publishers Weekly </i>review of <i>Sweetwater Gap</i></p>
<p class="tx1" id="d12e40">“Oh my! Denise Hunter knows how to write! <i>A Convenient Groom </i>is a love story overflowing with emotion, tenderness and attraction that captivated me from beginning to end . . . I can’t recommend this book highly enough - for its beautiful love story and the stunning allegory of God’s unconditional and sacrificial love. <i>A Convenient Groom </i>is a must read.”</p>
<p class="txr" id="d12e48">—RelzReviewz</p>
<p class="tx1" id="d12e50">“. . . a romantic adventure about unconditional love and forgiveness.”</p>
<p class="txr" id="d12e52">—<i>Library Journal </i>review of <i>Surrender Bay</i></p>
<p class="tx1" id="d12e59">“Hunter’s characters are well drawn and familiar. [W]ill appeal to all women readers with the taste for a good love story.”</p>
<p class="txr" id="d12e61">—<i>Foreword </i>magazine review of <i>Surrender Bay</i></p>
<p class="tx1" id="d12e68">“No one can write a story that grips the heart like Denise Hunter. If you like Karen Kingsbury or Nicholas Sparks, this is an author you’ll love.” </p>
<p class="txr" id="d12e70">—Colleen Coble, author of <i>Lonestar Sanctuary</i></p>
<p class="tx1" id="d12e75">“Denise Hunter skillfully paints a story of desperate choices with dire consequences.”</p>
<p class="txr" id="d12e77">—Diann Hunt, author of <i>Hot Flashes and Cold Cream</i></p>
<p class="tx1" id="d12e81">“In <i>Finding Faith </i>Denise Hunter once again brings me to tears with her thought-provoking story. For depth and emotion, this author always hits her mark.”</p>
<p class="txr" id="d12e86">—Kristin Billerbeck, author of <i>Split Ends</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hunt_9781595542595_epub_c2_r1.vue?dffed99e